import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getControlStyle, setImage } from '../../helper';
import CommonAction from '../../../Pages/Library/DPP/Library/TemplateComponent/CommonAction';
import noImage from '../../../assets/images/no-image.png';
import GoogleMapComponent from '../../GoogleMapComponent';
import { getBOMOptions } from '../../../Pages/Library/BomLibrary/store/BomLibrary.action';
import { fetchDPPBomProductJourney } from '../../../Pages/DevlopmentOrder/DPPModule/store/DPPModule.action';

export function ProductJourney(props) {
  const { t } = useTranslation('common');
  const {
    subHeaderTitle,
    productJourneyDescription,
    otherConfiguration,
    fromForm,
    dataIndex,
    editingInput,
    deleteItem,
    tier,
    verticalLine,
    transportIcon,
    factoryData,
    dppAddEditAccess,
    sectionId,
    setDppState,
    DPPstate,
    expColl,
    libraryBasicData,
  } = props;

  const reducer = useSelector((reducerstate) => reducerstate);
  const {
    BomLibraryDetails: { bomOptionsList },
    BOMConfigDetails: { productDetails },
    DPPProductReducer: { dppSelectedBOMData, devProductData },
  } = reducer;
  const FactoryName = t('PRODUCT_JOURNEY.FACTORY');
  const CountryName = t('PRODUCT_JOURNEY.COUNTRY');
  const NoOfWorkers = t('PRODUCT_JOURNEY.NO_OF_WORKERS');
  const EthicalAudit = t('PRODUCT_JOURNEY.ETHICAL_AUDIT');

  const dispatch = useDispatch();
  const handleImageError = (event) => {
    event.target.src = noImage;
  };

  const toggleDrop = () => {
    setDppState((otherStates) => ({
      ...otherStates,
      journeyExp: !expColl?.journeyExp,
    }));
  };

  useEffect(() => {
    if (props?.navigateId === 'product-journey-id') {
      setDppState((otherStates) => ({
        ...otherStates,
        navigateId: null,
        journeyExp: true,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.navigateId]);

  useEffect(() => {
    const fn = async (params) => {
      await dispatch(fetchDPPBomProductJourney(props?.devOrderId, params));
    };
    if (props?.bomType && props?.bomType?.length > 0 && props?.devOrderId) {
      const bomTypeIds = props?.bomType?.map((res) => res?.id);
      const params = {
        bomType: bomTypeIds,
      };
      fn(params);
    }
  }, [props?.bomType]);

  useEffect(() => {
    const fn = async () => {
      await dispatch(
        getBOMOptions({
          isAllRecord: true,
          productTypeId: devProductData?.supplierType?._id,
        }),
      );
    };
    if (devProductData?.supplierType?._id) {
      fn();
    }
  }, [devProductData?.supplierType?._id]);

  useEffect(() => {
    if (libraryBasicData?.productTypeId?.length > 0) {
      const callApi = async () => {
        if (libraryBasicData?.productTypeId?.length > 0) {
          await dispatch(
            getBOMOptions({
              isAllRecord: true,
              productTypeId: libraryBasicData?.productTypeId.map((res) => res?._id),
            }),
          );
        }
      };
      callApi();
    }
  }, [libraryBasicData?.productTypeId]);

  // Add this function inside the ProductJourney component, before the renderTierDetails function
  const renderTierDetails = (tierData, item = null) => {
    const isTier1 = tierData?.value === 'Tier1';
    const factory = isTier1 ? factoryData?.[0] : null;

    return (
      <>
        {item && (
          <div className="detail-card">
            <strong>{bomOptionsList.find((opt) => opt._id === item?.id)?.name || 'Component'}</strong>:NA
          </div>
        )}
        <div className="detail-card">
          <strong>{FactoryName}</strong>: {isTier1 ? factory?.factoryName || 'NA' : 'NA'}
        </div>
        <div className="detail-card">
          <strong>{CountryName}</strong>: {isTier1 ? factory?.country || 'NA' : 'NA'}
        </div>
        <div className="detail-card">
          <strong>{NoOfWorkers}</strong>: {isTier1 ? factory?.noOfWorkers || 'NA' : 'NA'}
        </div>
        <p
          className="mb-0"
          style={getControlStyle(
            otherConfiguration,
            `${tierData?.value}DescriptionAlign`,
            `${tierData?.value}DescriptionColor`,
            `${tierData?.value}DescriptionBold`,
          )}
        >
          {tierData?.tierDescription}
          {tierData?.value !== 'Tier1' &&
            (tierData.hasOwnProperty('ethicalAuditDPPDescription') ||
              tierData.hasOwnProperty('ethicalAuditIcon') ||
              tierData.hasOwnProperty('ethicalStatus') ||
              tierData.hasOwnProperty('ethicalAuditDPPStatus')) && (
              <div className="ethical-audit-container mt-2">
                <span className={`status ${statusClass(tierData, factory)}`} />
                <div className="top-detail">
                  <div>
                    <h4 className="title">{EthicalAudit}</h4>
                    <p className="status-text">{tierData?.ethicalAuditDPPStatus}</p>
                  </div>
                  <figure>
                    <img src={tierData?.ethicalAuditIcon ? setImage(tierData.ethicalAuditIcon) : noImage} alt="Ethical Audit Icon" onError={handleImageError} />
                  </figure>
                </div>
                <div>{tierData?.ethicalAuditDPPDescription}</div>
              </div>
            )}
        </p>
      </>
    );
  };

  const createGoogleMapCoordinates = useMemo(() => {
    const nestedPolylines = [];

    const isDuplicate = (array, target) =>
      array.some((existing) => existing.lat === target.lat && existing.lng === target.lng && existing.name === target.name);

    if (props?.profileDetails?.coordinates) {
      const startPointTier0 = {
        lat: props.profileDetails.coordinates.lat || 0,
        lng: props.profileDetails.coordinates.lng || 0,
        name: props.profileDetails.country || '',
        endPointsTier1: [],
      };

      if (props?.factoryData?.length) {
        const tier1Factory = props.factoryData[0]; // Only first factory considered

        if (tier1Factory?.coordinates) {
          const tier1Coordinates = {
            lat: tier1Factory.coordinates.lat || 0,
            lng: tier1Factory.coordinates.lng || 0,
            name: tier1Factory.country || '',
            endPointsTier2: [],
          };

          if (props.bomType?.length && dppSelectedBOMData?.length) {
            props.bomType.forEach((bomT) => {
              bomT?.allBoms?.forEach((bom) => {
                const bomTypeBasedBom = dppSelectedBOMData.find((vl) => vl?._id === bom);
                if (!bomTypeBasedBom) return;
                const bomSupplierFact =
                  bomTypeBasedBom?.supplierDetails?.factoriesDetails ||
                  bomTypeBasedBom?.productImpact?.tierTwo?.componentSupplierObj?.componentSupplier?.factoriesDetails;

                if (bomSupplierFact?.coordinates) {
                  const tier2Coordinates = {
                    lat: bomSupplierFact.coordinates.lat || 0,
                    lng: bomSupplierFact.coordinates.lng || 0,
                    name: bomSupplierFact.country || '',
                    endPointsTier3: [],
                  };

                  // Tier 3
                  const rawMaterialProcessor = bomTypeBasedBom?.productImpact?.tierThree?.rawMaterialProcessor;
                  if (rawMaterialProcessor?.factoriesDetails?.coordinates) {
                    const tier3Coordinates = {
                      lat: rawMaterialProcessor.factoriesDetails.coordinates.lat || 0,
                      lng: rawMaterialProcessor.factoriesDetails.coordinates.lng || 0,
                      name: rawMaterialProcessor.factoriesDetails.country || '',
                      endPointsTier4: [],
                    };

                    // Tier 4
                    const rawMaterialExtractor = bomTypeBasedBom?.productImpact?.tierFour?.rawMaterialExtractor;
                    if (rawMaterialExtractor?.factoriesDetails?.coordinates) {
                      const tier4Coordinates = {
                        lat: rawMaterialExtractor.factoriesDetails.coordinates.lat || 0,
                        lng: rawMaterialExtractor.factoriesDetails.coordinates.lng || 0,
                        name: rawMaterialExtractor.factoriesDetails.country || '',
                      };

                      if (!isDuplicate(tier3Coordinates.endPointsTier4, tier4Coordinates)) {
                        tier3Coordinates.endPointsTier4.push(tier4Coordinates);
                      }
                    }

                    if (!isDuplicate(tier2Coordinates.endPointsTier3, tier3Coordinates)) {
                      tier2Coordinates.endPointsTier3.push(tier3Coordinates);
                    }
                  }

                  if (!isDuplicate(tier1Coordinates.endPointsTier2, tier2Coordinates)) {
                    tier1Coordinates.endPointsTier2.push(tier2Coordinates);
                  }
                }
              });
            });
          }

          if (tier1Coordinates.lat || tier1Coordinates.lng || tier1Coordinates.endPointsTier2.length > 0) {
            if (!isDuplicate(startPointTier0.endPointsTier1, tier1Coordinates)) {
              startPointTier0.endPointsTier1.push(tier1Coordinates);
            }
          }
        }
      }

      nestedPolylines.push({ startPointTier0 });
    }
    return nestedPolylines;
  }, [dppSelectedBOMData, props?.bomType, props?.factoryData, props?.profileDetails]);

  const renderToggleIcon = () => {
    return (
      <span
        id="collapsible-journey"
        className={`icon-new-down-arrow-icon drop-icon ml-16 f-18 ${expColl?.journeyExp ? 'rotated' : ''}`}
        onClick={() => toggleDrop()}
      />
    );
  };

  const shouldShowMap = createGoogleMapCoordinates?.length;
  const shouldPublishHtml = DPPstate?.publishHtml;

  let googleMapComponent;
  if (shouldShowMap) {
    if (shouldPublishHtml) {
      googleMapComponent = <GoogleMapComponent nestedLevelCoordinates={createGoogleMapCoordinates} showMapImage />;
    } else {
      googleMapComponent = <GoogleMapComponent nestedLevelCoordinates={createGoogleMapCoordinates} showMapImage={props?.mapOptionType !== 'google'} />;
    }
  }

  const statusClass = (tierData, supplierDetails) => {
    const statusPending = 'sts-pending';
    if (tierData?.ethicalStatus === 'Approved' || tierData?.ethicalStatus === 'Rejected') {
      if (tierData?.ethicalStatus === 'Approved') {
        return 'sts-approve';
      }
      if (tierData?.ethicalStatus === 'Rejected') {
        return 'sts-reject';
      }
      return statusPending;
    }
    if (supplierDetails?.supplierFileStatus) {
      if (supplierDetails?.supplierFileStatus === 'Approved' || supplierDetails?.supplierFileStatus.status === 'Approved') {
        return 'sts-approve';
      }
      if (supplierDetails?.supplierFileStatus === 'Rejected' || supplierDetails?.supplierFileStatus.status === 'Rejected') {
        return 'sts-reject';
      }
      return statusPending;
    }
    return statusPending;
  };

  const getTierDetailsCardData = (re, tierData, item, supplierDetails) => {
    return (
      <React.Fragment key={re._id}>
        <div className="detail-card">
          <strong>{bomOptionsList.filter((res) => res._id === item.id).map((data) => data?.name)}</strong>:{re?.referenceCode}
        </div>
        <div className="detail-card">
          <strong>{FactoryName}</strong>: {re?.factoryName || 'NA'}
        </div>
        <div className="detail-card">
          <strong>{CountryName}</strong>: {re?.country || 'NA'}
        </div>
        <div className="detail-card">
          <strong>{NoOfWorkers}</strong>: {re?.noOfWorkers || 'NA'}
        </div>
        <p
          style={getControlStyle(
            otherConfiguration,
            `${tierData?.value}DescriptionAlign`,
            `${tierData?.value}DescriptionColor`,
            `${tierData?.value}DescriptionBold`,
          )}
        >
          {tierData?.tierDescription}
          {(tierData?.value !== 'Tier1'
            ? tierData.hasOwnProperty('ethicalAuditDPPDescription') ||
              tierData.hasOwnProperty('ethicalAuditIcon') ||
              tierData.hasOwnProperty('ethicalStatus') ||
              tierData.hasOwnProperty('ethicalAuditDPPStatus')
            : true) && (
            <div className="ethical-audit-container mt-2">
              <span className={`status ${statusClass(tierData, supplierDetails)}`} />
              <div className="top-detail">
                <div>
                  <h4 className="title">{EthicalAudit}</h4>
                  <p className="status-text">{tierData?.ethicalAuditDPPStatus}</p>
                </div>
                <figure>
                  <img src={tierData?.ethicalAuditIcon ? setImage(tierData?.ethicalAuditIcon) : noImage} alt="Ethical Audit Icon" onError={handleImageError} />
                </figure>
              </div>
              <div>{tierData?.ethicalAuditDPPDescription}</div>
            </div>
          )}
        </p>
      </React.Fragment>
    );
  };

  const tire4Render = (tierData) => {
    return tierData?.value === 'Tier4' && props?.bomType?.length > 0 ? (
      props?.bomType?.map((item) =>
        item.allBoms.length > 0
          ? item.allBoms.map((bom) => (
              <div key={`${item.id}-${bom}`}>
                {dppSelectedBOMData
                  .filter((res) => res._id === bom)
                  .map((re) => {
                    const reObj = {
                      referenceCode: re?.referenceCode,
                      factoryName: re?.productImpact?.tierFour?.rawMaterialExtractor?.factoriesDetails?.factoryName || 'NA',
                      country: re?.productImpact?.tierFour?.rawMaterialExtractor?.factoriesDetails?.country || 'NA',
                      noOfWorkers: re?.productImpact?.tierFour?.rawMaterialExtractor?.factoriesDetails?.noOfWorkers || 'NA',
                    };
                    return getTierDetailsCardData(reObj, tierData, item, re?.supplierDetails);
                  })}
              </div>
            ))
          : renderTierDetails(tierData),
      )
    ) : (
      <>
        <div className="detail-card">
          <strong>{FactoryName}</strong>: {tierData?.value === 'Tier1' ? factoryData?.[0]?.factoryName || 'NA' : 'NA'}
        </div>
        <div className="detail-card">
          <strong>{CountryName}</strong>: {tierData?.value === 'Tier1' ? factoryData?.[0]?.country || 'NA' : 'NA'}
        </div>
        <div className="detail-card">
          <strong>{NoOfWorkers}</strong>: {tierData?.value === 'Tier1' ? factoryData?.[0]?.noOfWorkers || 'NA' : 'NA'}
        </div>
        <p
          className="mb-0"
          style={getControlStyle(
            otherConfiguration,
            `${tierData?.value}DescriptionAlign`,
            `${tierData?.value}DescriptionColor`,
            `${tierData?.value}DescriptionBold`,
          )}
        >
          {tierData?.tierDescription}
          {(tierData?.value !== 'Tier1'
            ? tierData.hasOwnProperty('ethicalAuditDPPDescription') ||
              tierData.hasOwnProperty('ethicalAuditIcon') ||
              tierData.hasOwnProperty('ethicalStatus') ||
              tierData.hasOwnProperty('ethicalAuditDPPStatus')
            : true) && (
            <div className="ethical-audit-container mt-2">
              <span className={`status ${statusClass(tierData, factoryData?.[0])}`} />
              <div className="top-detail">
                <div>
                  <h4 className="title">{EthicalAudit}</h4>
                  <p className="status-text">{tierData?.ethicalAuditDPPStatus}</p>
                </div>
                <figure>
                  <img src={tierData?.ethicalAuditIcon ? setImage(tierData?.ethicalAuditIcon) : noImage} alt="Ethical Audit Icon" onError={handleImageError} />
                </figure>
              </div>
              <div>{tierData?.ethicalAuditDPPDescription}</div>
            </div>
          )}
        </p>
      </>
    );
  };

  const tire3Render = (tierData) => {
    return tierData?.value === 'Tier3' && props?.bomType?.length > 0
      ? props?.bomType?.map((item) =>
          item.allBoms.length > 0
            ? item.allBoms.map((bom) => (
                <div key={`${item.id}-${bom}`}>
                  {dppSelectedBOMData
                    .filter((res) => res._id === bom)
                    .map((re) => {
                      const reObj = {
                        referenceCode: re?.referenceCode,
                        factoryName: re?.productImpact?.tierThree?.rawMaterialProcessor?.factoriesDetails?.factoryName || 'NA',
                        country: re?.productImpact?.tierThree?.rawMaterialProcessor?.factoriesDetails?.country || 'NA',
                        noOfWorkers: re?.productImpact?.tierThree?.rawMaterialProcessor?.factoriesDetails?.noOfWorkers || 'NA',
                      };
                      return getTierDetailsCardData(reObj, tierData, item, re?.supplierDetails);
                    })}
                </div>
              ))
            : renderTierDetails(tierData),
        )
      : tire4Render(tierData);
  };

  return (
    <div className="product-journey-control" id={sectionId}>
      {(tier?.length || createGoogleMapCoordinates?.length || subHeaderTitle || productJourneyDescription) && (
        <div>
          <h3 className="main-title d-flex align-items-center">
            <span className="title-text">{t('PRODUCT_JOURNEY.TITLE')}</span>
            {renderToggleIcon()}
          </h3>
          <p className="f-16 mb-8" style={getControlStyle(otherConfiguration, 'subHeaderAlign', 'subHeaderColor', 'subHeaderBold')}>
            {subHeaderTitle}
          </p>
          <div className="journey-desc">
            <p
              className={`${expColl?.journeyExp && 'full-view'} fixed-description`}
              style={getControlStyle(otherConfiguration, 'journeyDescAlign', 'journeyDescColor', 'journeyDescBold')}
            >
              {productJourneyDescription}
            </p>
          </div>
        </div>
      )}

      {!tier?.length && !createGoogleMapCoordinates?.length && !subHeaderTitle && !productJourneyDescription && (
        <div className="empty-product-journey">
          <div className="image-container">
            <i className="icon icon-DAM-1" />
          </div>
          <div className="description">{t('DPP.CONTROL.PRODUCTJOURNEY.DESCRIPTION_PLACEHOLDER')}</div>
          <div className="ethical-audit">
            <p>{t('DPP.CONTROL.PRODUCTJOURNEY.ETHICAL_AUDIT_PLACEHOLDER')}</p>
            <i className="icon icon-BOM-Library " />
          </div>
        </div>
      )}
      {/* default page end */}
      <div id="product-journey" className={expColl?.journeyExp ? 'd-block' : 'd-none'}>
        {googleMapComponent}
        <div className="all-tier-container">
          {tier?.length > 0 &&
            tier
              ?.sort((a, b) => {
                const tierNumberA = parseInt(a?.label?.split(' ')[1], 10);
                const tierNumberB = parseInt(b?.label?.split(' ')[1], 10);
                return tierNumberA - tierNumberB;
              })
              ?.map((tierData, index) => {
                return (
                  <div className="tier-container" key={index}>
                    <span
                      style={{ borderRight: `${otherConfiguration?.borderThickness || '5px'} ${verticalLine} ${otherConfiguration.verticalLineColor}` }}
                      className="tier-vertical-line"
                    />
                    <img
                      className="transport-icon"
                      src={
                        transportIcon
                          ? setImage(transportIcon)
                          : `https://${process.env.REACT_APP_BUCKET_NAME}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${process.env.REACT_APP_COMMON_RESOURCE}/Transport_Icon.svg`
                      }
                      alt=""
                      onError={handleImageError}
                    />
                    <h3 className="title">
                      {tierData?.name}
                      <img
                        className="tier-icon"
                        src={
                          tierData?.tierIcon
                            ? setImage(tierData.tierIcon)
                            : `https://${process.env.REACT_APP_BUCKET_NAME}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${
                                process.env.REACT_APP_COMMON_RESOURCE
                              }/Tier_${tierData?.value?.replace('Tier', '') || '1'}.svg`
                        }
                        alt=""
                        onError={handleImageError}
                      />
                    </h3>
                    {tierData?.value === 'Tier2' && props?.bomType?.length > 0
                      ? props?.bomType?.map((item) =>
                          item?.allBoms?.length > 0 ? (
                            item?.allBoms?.map((bom) => (
                              <div key={`${item.id}-${bom}`}>
                                {dppSelectedBOMData
                                  .filter((res) => res._id === bom)
                                  .map((re) => {
                                    const reObj = {
                                      referenceCode: re?.referenceCode,
                                      factoryName:
                                        re?.supplierDetails?.factoriesDetails?.factoryName ||
                                        re?.productImpact?.tierTwo?.componentSupplierObj?.componentSupplier?.factoriesDetails?.factoryName ||
                                        'NA',
                                      country:
                                        re?.supplierDetails?.factoriesDetails?.country ||
                                        re?.productImpact?.tierTwo?.componentSupplierObj?.componentSupplier?.factoriesDetails?.country ||
                                        'NA',
                                      noOfWorkers:
                                        re?.supplierDetails?.factoriesDetails?.noOfWorkers ||
                                        re?.productImpact?.tierTwo?.componentSupplierObj?.componentSupplier?.factoriesDetails?.noOfWorkers ||
                                        'NA',
                                    };
                                    return getTierDetailsCardData(reObj, tierData, item, re?.supplierDetails);
                                  })}
                              </div>
                            ))
                          ) : (
                            <>
                              <div className="detail-card">
                                <strong>{bomOptionsList.filter((res) => res._id === item.id).map((data) => data?.name)}</strong>:NA
                              </div>
                              <div className="detail-card">
                                <strong>{FactoryName}</strong>:NA
                              </div>
                              <div className="detail-card">
                                <strong>{CountryName}</strong>:NA
                              </div>
                              <div className="detail-card">
                                <strong>{NoOfWorkers}</strong>:NA
                              </div>
                              <p
                                className="mb-0"
                                style={getControlStyle(
                                  otherConfiguration,
                                  `${tierData?.value}DescriptionAlign`,
                                  `${tierData?.value}DescriptionColor`,
                                  `${tierData?.value}DescriptionBold`,
                                )}
                              >
                                {tierData?.tierDescription}
                                {(tierData?.value !== 'Tier1'
                                  ? tierData.hasOwnProperty('ethicalAuditDPPDescription') ||
                                    tierData.hasOwnProperty('ethicalAuditIcon') ||
                                    tierData.hasOwnProperty('ethicalStatus') ||
                                    tierData.hasOwnProperty('ethicalAuditDPPStatus')
                                  : true) && (
                                  <div className="ethical-audit-container mt-2">
                                    <span className={`status ${statusClass(tierData, factoryData?.[0])}`} />
                                    <div className="top-detail">
                                      <div>
                                        <h4 className="title">{EthicalAudit}</h4>
                                        <p className="status-text">{tierData?.ethicalAuditDPPStatus}</p>
                                      </div>
                                      <figure>
                                        <img
                                          src={tierData?.ethicalAuditIcon ? setImage(tierData?.ethicalAuditIcon) : noImage}
                                          alt="Ethical Audit Icon"
                                          onError={handleImageError}
                                        />
                                      </figure>
                                    </div>
                                    <div>{tierData?.ethicalAuditDPPDescription}</div>
                                  </div>
                                )}
                              </p>
                            </>
                          ),
                        )
                      : tire3Render(tierData)}
                  </div>
                );
              })}
        </div>
      </div>

      {/* </>
      )} */}
      {fromForm && (
        <CommonAction
          editingInput={editingInput}
          deleteItem={deleteItem}
          dataIndex={dataIndex}
          dppAddEditAccess={dppAddEditAccess}
          isProductArchived={productDetails?.isArchived}
        />
      )}
    </div>
  );
}
export default ProductJourney;
